/** Find as a conversation: what the household needs, asked one missing piece at a time, read back, then searched. */
export const need = {
    "need.start": "What do you need done? Say it in your own words.",
    "need.ask.trade": "Which kind of worker do you need?",
    "need.again": "Sorry, I didn't catch that.",
    "need.ask.area": "Which area is the work in?",
    "need.ask.when": "When do you need someone? You can add a time, like tomorrow 10 am.",
    "need.ask.hour": "What time should they come?",
    "when.hour": "{time}",
    "when.any_time": "Any time",
    "hour.morning": "{h} am",
    "hour.afternoon": "{h} pm",
    "hour.evening": "{h} pm",
    "need.ask.budget": "What's the most you'd pay? It stays on this phone; workers never see it.",
    "need.band_month": "In {city}, people usually pay {low} to {high} a month for this.",
    "need.band_visit": "In {city}, people usually pay {low} to {high} a visit for this.",
    "need.again_budget": "Say an amount in rupees, like 700.",
    "need.got_budget": "Most you'll pay: {price}, noted.",
    "need.err_long": "That's long. Say it in fewer words.",
    "need.summary": "{trade} in {area}. When: {when}.",
    "need.summary_time": "Time: {time}.",
    "need.summary_words": 'Workers will read: "{words}"',
    "need.summary_detail": "{question} {answer}",
    "need.summary_budget": "Most you'll pay: {budget}. It stays on this phone.",
    "need.confirm": "Shall I look for someone?",
    "need.what_change": "What should I change?",
    "need.field_trade": "Kind of work",
    "need.field_detail": "Details",
    "need.field_budget": "Most I'll pay",
    "need.searching": "Looking for someone near {area}…",
    "need.found": "Here is who can help nearby. Tick up to three, then ask.",
    "need.nobody": "Nobody within {km} km yet. Look further, or change something?",
    "need.change": "Change something",
    "need.asked": "Asked. Their agents will talk to yours — follow it in My jobs.",
    "need.start_to": "What do you need {name} for? Say it in your own words.",
    "need.confirm_to": "Shall I ask {name}?",
    "need.asking_to": "Asking {name}…",
    "need.composer": "Tell me what you need",
    "need.placeholder": "Type what you need…",
    "need.reading": "Reading what you said…",
    "need.date_ok": "Use this date",
};
//# sourceMappingURL=need.js.map